/**
 * Class names used to apply on keypad and input DOM elements.
 *
 * @readonly
 * @enum {string}
 * @public
 * @memberof Mojito.Modules.Keypad
 */
export default {
    CUSTOM_TEXT_INPUT: 'CustomTextInput',
    KEYPAD_BUTTON: 'KeypadButton',
};
